<template>
    <section class="" :style="{ background: colorSection}">
      <div class="max-w-screen-xl px-4 mx-auto lg:px-6" :class="bigMarginContainer ? 'my-8 lg:my-16' : 'my-8'">
        <div class="max-w-screen-md mx-auto text-center">
          <div class="mb-4 font-extrabold h2" v-html="mainHeading"></div>
          <div class="mb-4 text-gray-700 h4 font-open-sans" v-html="paragraph"></div>
          <button :style="{ background: colorButton}" @click="scrollTo(ctaLink)" class="text-white bnt-basic xs-max:w-full" v-html="ctaText"></button>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    bigMarginContainer: {
    type: Boolean,
    default: false
    },
    colorSection: {
    type: String,
    default: "#ebdfd3" 
    },
    colorButton: {
    type: String,
    default: "#ebdfd3" 
    },
    mainHeading: {
      type: String,
      default: 'Ready to Elevate Your Morning Ritual?'
    },
    paragraph: {
      type: String,
      default: 'Embrace wellness, energy, and joy in every cup. The Lifeboost Latte Bundle is more than coffee—it\'s a commitment to a better you.'
    },
    ctaLink: {
      type: String,
      default: 'the-products'
    },
    ctaText: {
      type: String,
      default: 'Start My Lifeboost Experience'
    }
  });

  defineBuilderComponent({
    friendlyName: "Heading CTA Button",
    inputs: [
    { name: 'bigMarginContainer', type: 'boolean', defaultValue: false },
    {
      name: "colorSection",
      type: "color",
      defaultValue: "#ebdfd3"
    },
    {
      name: "colorButton",
      type: "color",
      defaultValue: "#105857"
    },
    
    {
      name: 'mainHeading',
      type: 'richText',
      defaultValue: 'Ready to Elevate Your Morning Ritual?'
    },
    {
      name: 'paragraph',
      type: 'richText',
      defaultValue: 'Embrace wellness, energy, and joy in every cup. The Lifeboost Latte Bundle is more than coffee—it\'s a commitment to a better you.'
    },
    {
      name: 'ctaLink',
      type: 'text',
      defaultValue: 'the-products'
    },
    {
      name: 'ctaText',
      type: 'richText',
      defaultValue: 'Start My Lifeboost Experience'
    }
  ]
});
  </script>
  
  <style scoped>
  /* Your styles here */
  </style>